


export const setTemplates =(templates)=>({
    type:"IT_INIT_DATA",
    templates
});

